/* eslint-disable no-unused-vars */
export default class BaseMiddleware {
    /**
     * Avalia se deve executar este middleware ou não
     *
     * @param {Route} _to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve executar este middleware?
     */
    shouldRun(_to, _from) {
        return true
    }

    /**
     * Executa ações sobre esta rota
     *
     * @param {Route} _to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve retornar false quando este middleware modifica a rota com next
     */
    handle(_to, _from, _next) {
        return true
    }
}
